<div class="login-card" *ngIf="isLogin && !isReset">
  <div class="login-card-overlay"></div>
  <div>
    <div class="login-main">
      <div>
        <a class="logo" routerLink="/">
          <!-- <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="loginPage" /> -->
          <!-- <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="loginPage" /> -->
          <img
            class="img-fluid for-light"
            src="assets/images/logo/report_logo.svg"
            alt="looginpage"
          />
          <img
            class="img-fluid for-dark"
            src="assets/images/logo/report_logo.svg"
            alt="looginpage"
          />
        </a>
      </div>
      <form class="theme-form" [formGroup]="loginForm">
        <h4>{{ "Sign In To Account" | translate }}</h4>
        <div class="d-flex ai-c flex-col login-gap">
          <!-- <p> {{'Enter Email' | translate}} </p> -->
          <div class="form-group">
            <!-- <label class="col-form-label">{{'Forms.Email' | translate}}</label> -->
            <input
              class="form-control"
              type="email"
              required=""
              placeholder="{{ 'Forms.Email Or Phone' | translate }}"
              name="user_name"
              formControlName="user_name"
            />
            <div
              *ngIf="loginForm.controls['user_name'].touched && loginForm.controls['user_name'].errors?.['required']"
              class="text text-danger mt-1"
            >
              {{ "Validations.Email Is Required" | translate }}
            </div>
            <div
              *ngIf="loginForm.controls['user_name'].touched && loginForm.controls['user_name'].errors?.['user_name']"
              class="text text-danger mt-1"
            >
              {{ "Validations.Invalid Email" | translate }}
            </div>
          </div>
          <div class="form-group">
            <!-- <label class="col-form-label">{{'Forms.Password' | translate}}</label> -->
            <input
              class="form-control"
              [type]="show ? 'text' : 'password'"
              name="password"
              formControlName="password"
              required=""
              placeholder="{{ 'Forms.Password' | translate }}"
            />
            <div class="show-hide" (click)="showPassword()" *ngIf="!show">
              <!-- <span class="show">{{'Forms.Show' | translate}}</span> -->
              <div class="img">
                <img src="assets/images/icons/show_pass.svg" alt="" />
              </div>
            </div>
            <div class="show-hide" (click)="showPassword()" *ngIf="show">
              <!-- <span class="Hide">{{'Forms.Hide' | translate}}</span> -->
              <div class="img">
                <img src="assets/images/icons/hide_pass.svg" alt="" />
              </div>
            </div>
            <div
              *ngIf="loginForm.controls['password'].touched && loginForm.controls['password'].errors?.['required']"
              class="text text-danger mt-1"
            >
              {{ "Validations.Password Is Required" | translate }}
            </div>
          </div>
          <div class="form-group mb-0">
            <div>
              <button
                class="transparent-button change-language"
                (click)="
                  changeLanguage(translate.currentLang == 'ar' ? 'en' : 'ar');
                  customizeLayoutType(
                    translate.currentLang == 'ar' ? 'rtl' : 'ltr'
                  )
                "
              >
                <!-- <img src="assets/svg/translate.svg" alt=""> -->
                <span class="language-icon">{{ isDirRTL ? "e" : "a" }}</span>
                <span *ngIf="isDirRTL">الإنجليزية</span>
                <span *ngIf="!isDirRTL">Arabic</span>
              </button>
            </div>
            <a (click)="changeResetPasswordForm()" class="link">{{
              "Forms.Forget Password" | translate
            }}</a>
            <!-- <a [routerLink]="'/auth/forgot-password'" class="link">{{'Forms.Forget Password' | translate}}</a> -->
          </div>
          <div class="flex jc-sb ai-c flex-col gap-15 full-width">
            <!-- <a [routerLink]="'/auth/forgot-password'" class="forgetPassword">{{'Forms.Forget Password' | translate}}</a> -->
            <div class="text-end login-button-box full-width">
              <button class="login-button" (click)="login()" type="button">
                <span>{{ "Forms.Sign In" | translate }}</span>
              </button>
            </div>
            <!-- <p class="mb-0 cursor-pointer">
              {{ "Don't Have Account" | translate }}
              <a (click)="changeLogin(false)" class="ms-2 authLink">{{
                "Create Your Account" | translate
              }}</a>
              <a [routerLink]="'/auth/register'" class="ms-2 authLink">{{'Create Your Account' | translate}}</a>
            </p> -->
          </div>
          <div class="iam-login">
            <div class="iam-wrapper">
              <div class="iam-login-buttons">
                <a id="lbtnIamLogin" class="tooltip-iam btnsso nic">
                  <img
                    src="https://www.iam.gov.sa/img/secure.svg"
                    alt="Secure Login"
                    class="secure-img"
                  />
                  للدخول من خلال بوابة النفاذ الوطني الموحد
                </a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  class="login-card register-card"
  *ngIf="!isLogin && isRegister && !isReset"
>
  <div class="login-card-overlay"></div>
  <div>
    <div class="login-main">
      <div>
        <a class="logo" routerLink="/">
          <!-- <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="loginPage" /> -->
          <!-- <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="loginPage" /> -->
          <img
            class="img-fluid for-light"
            src="assets/images/logo/reportLogo.png"
            alt="loginPage"
          />
          <img
            class="img-fluid for-dark"
            src="assets/images/logo/reportLogo.png"
            alt="loginPage"
          />
        </a>
      </div>
      <form class="theme-form" [formGroup]="registerForm">
        <h4>{{ "Enter Personal Details" | translate }}</h4>
        <div class="d-flex ai-c flex-col login-gap">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  formControlName="full_name"
                  required=""
                  placeholder="{{ 'Forms.Full Name' | translate }}"
                />
                <app-input-error
                  [control]="registerForm.get('full_name')"
                  [formSubmitted]="formSubmitted"
                ></app-input-error>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  formControlName="full_name_latin"
                  required=""
                  placeholder="{{ 'Forms.Full Name En' | translate }}"
                />
                <app-input-error
                  [control]="registerForm.get('full_name_latin')"
                  [formSubmitted]="formSubmitted"
                ></app-input-error>
              </div>
            </div>
            <div class="col-md-6">
              <input
                type="password"
                class="form-control"
                formControlName="password"
                id="password"
                required
                placeholder="{{ 'Forms.Password' | translate }}"
              />
              <app-input-error
                [control]="registerForm.get('password')"
                [formSubmitted]="formSubmitted"
                [customMsg]="{ minLength: 'الحد الأدنى 8 عناصر' }"
              ></app-input-error>
            </div>
            <div class="col-md-6">
              <input
                type="password"
                class="form-control"
                formControlName="password_confirmation"
                id="confirmPaasword"
                required
                placeholder="{{ 'Forms.Confirm Password' | translate }}"
              />
              <app-input-error
                [control]="registerForm.get('password_confirmation')"
                [formSubmitted]="formSubmitted"
                [customMsg]="{ minLength: 'الحد الأدنى 8 عناصر' }"
              ></app-input-error>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <!-- [ngClass]="{'errorInput': formSubmitted && !formValid && f['nationality_id'].errors, 'isValid': formSubmitted && !f['nationality_id'].errors }" -->
                <select
                  class="form-select"
                  formControlName="country_id"
                  (change)="enableNationalId(rF['country_id'].value)"
                  required
                  id="Nationalities"
                >
                  <option value="" disabled selected>
                    {{ "Forms.Choose Nationality" | translate }}
                  </option>
                  <option
                    *ngFor="let nationality of nationalities"
                    [value]="nationality.id"
                  >
                    {{
                      isDirRTL
                        ? nationality.nationality_name
                        : nationality.nationality_name_latin
                    }}
                  </option>
                </select>
                <app-input-error
                  [control]="registerForm.get('country_id')"
                  [formSubmitted]="formSubmitted"
                ></app-input-error>
                <!-- <label for="Nationalities" class="form-label">{{'Forms.Nationality' | translate}}</label>
                <select class="form-select" required="" id="Nationalities">
                  <option value="">{{'Forms.Choose Nationality' | translate}}</option>
                  <option *ngFor="let country of countries?.data" [value]="country.id">{{ isDirRTL ? country.country_name : country.country_name_latin}}</option>
                </select> -->
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input
                  *ngIf="registerForm.get('country_id')?.value == 1"
                  type="text"
                  class="form-control"
                  formControlName="national_id"
                  id="nationalId"
                  required
                  placeholder="{{ 'Forms.National Id' | translate }}"
                  onlyNumbers
                  [MaxDigit]="10"
                  startNationalIdOne
                />
                <input
                  *ngIf="registerForm.get('country_id')?.value != 1"
                  type="text"
                  class="form-control"
                  formControlName="national_id"
                  id="nationalId"
                  required
                  placeholder="{{ 'Forms.National Id' | translate }}"
                  onlyNumbers
                  [MaxDigit]="10"
                  startNationalIdTwo
                />
                <app-input-error
                  [control]="registerForm.get('national_id')"
                  [formSubmitted]="formSubmitted"
                  [customMsg]="{
                    minLength: 'رقم الهوية 10 أرقام',
                    maxLength: 'رقم الهوية 10 أرقام'
                  }"
                ></app-input-error>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input
                  class="form-control"
                  type="email"
                  formControlName="email"
                  required=""
                  placeholder="{{ 'Forms.Email' | translate }}"
                />
                <app-input-error
                  [control]="registerForm.get('email')"
                  [formSubmitted]="formSubmitted"
                ></app-input-error>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="phone"
                  formControlName="phone"
                  required
                  placeholder="{{ 'Forms.Phone' | translate }}"
                  onlyNumbers
                  [MaxDigit]="9"
                  startPhoneFive
                />
                <app-input-error
                  [control]="registerForm.get('phone')"
                  [formSubmitted]="formSubmitted"
                  [customMsg]="{
                    minLength: 'رقم الهاتف 9 أرقام',
                    maxLength: 'رقم الهاتف 9 أرقام'
                  }"
                >
                </app-input-error>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <input
                  id="address"
                  class="form-control"
                  type="text"
                  formControlName="address"
                  required=""
                  placeholder="{{ 'Forms.Address' | translate }}"
                />
                <app-input-error
                  [control]="registerForm.get('address')"
                  [formSubmitted]="formSubmitted"
                ></app-input-error>
              </div>
            </div>
            <div class="col-md-12">
              <label class="d-block" for="acceptTermsFlag">
                <input
                  formControlName="accept_terms_flag"
                  required
                  class="checkbox_animated"
                  id="acceptTermsFlag"
                  type="checkbox"
                  (change)="
                    acceptTermsAndConditions = !acceptTermsAndConditions
                  "
                />
                {{ "Accept Terms And Conditions" | translate }}
              </label>
            </div>
          </div>
          <div class="flex jc-sb ai-c mb-0 w-100">
            <div>
              <button
                class="transparent-button change-language"
                (click)="
                  changeLanguage(translate.currentLang == 'ar' ? 'en' : 'ar');
                  customizeLayoutType(
                    translate.currentLang == 'ar' ? 'rtl' : 'ltr'
                  )
                "
              >
                <img src="assets/svg/translate.svg" alt="" />
                <span *ngIf="translate.currentLang == 'ar'">الإنجليزية</span>
                <span *ngIf="translate.currentLang == 'en'">Arabic</span>
              </button>
            </div>
            <a
              class="terms-and-conditions"
              [routerLink]="'/terms-and-conditions'"
              >{{ "Terms And Conditions" | translate }}</a
            >
          </div>
          <div class="form-group mb-0">
            <button
              [disabled]="!acceptTermsAndConditions"
              class="btn btn-primary d-block w-100"
              type="button"
              (click)="register()"
            >
              {{ "Create Account" | translate }}
            </button>
          </div>
          <p class="mt-4 mb-0 cursor-pointer">
            {{ "Already Have Account" | translate
            }}<a class="ms-2 authLink" (click)="changeLogin(true)">{{
              "Forms.Sign In" | translate
            }}</a>
          </p>
          <!-- <p class="mt-4 mb-0">{{'Already Have Account' | translate}}<a class="ms-2 authLink" [routerLink]="'/auth/login'">{{'Forms.Sign In' | translate}}</a></p> -->
        </div>
      </form>
    </div>
  </div>
</div>

<div class="login-card" *ngIf="isReset">
  <div class="login-card-overlay"></div>
  <div>
    <div class="login-main">
      <div>
        <a class="logo" routerLink="/">
          <!-- <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="looginpage" /> -->
          <!-- <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage" /> -->
          <img
            class="img-fluid for-light"
            src="assets/images/logo/report_logo.svg"
            alt="looginpage"
          />
          <img
            class="img-fluid for-dark"
            src="assets/images/logo/report_logo.svg"
            alt="looginpage"
          />
        </a>
      </div>
      <form class="theme-form" [formGroup]="resetPasswordForm">
        <h4>{{ "Reset Your Password" | translate }}</h4>
        <div class="d-flex ai-c flex-col reset-form-gap">
          <div class="form-group" *ngIf="!codeSent && !codeVerified">
            <label class="col-form-label">{{
              "Forms.Enter Your Mobile Number" | translate
            }}</label>
            <div class="row">
              <div class="col-md-3">
                <input
                  class="form-control mb-1"
                  type="text"
                  value="+ 966"
                  readonly
                />
              </div>
              <div class="col-md-9">
                <input
                  class="form-control mb-1"
                  type="text"
                  placeholder="0000000000"
                  formControlName="phone"
                  onlyNumbers
                  [MaxDigit]="9"
                />
                <app-input-error
                  [control]="resetPasswordForm.get('phone')"
                  [formSubmitted]="formSubmitted"
                ></app-input-error>
              </div>
              <div class="col-12">
                <button
                  *ngIf="!codeSent"
                  class="btn btn-primary d-block w-100 m-t-10"
                  type="button"
                  (click)="sendCode()"
                >
                  {{ "Send" | translate }}
                </button>
              </div>
            </div>
          </div>
          <ng-container *ngIf="codeSent && !codeVerified">
            <div class="text-center">
              <span class="reset-password-link"
                >{{ "If don't receive OTP" | translate }}  <a
                  class="btn-link text-danger"
                  (click)="sendCode()"
                  >{{ "Resend" | translate }}</a
                ></span
              >
            </div>
            <div class="form-group">
              <label class="col-form-label pt-0">{{
                "Enter OTP" | translate
              }}</label>
              <div class="row otpValues">
                <div class="col">
                  <input
                    class="form-control text-center opt-text"
                    type="text"
                    placeholder="0"
                    [(ngModel)]="codeFirstDigit"
                    [ngModelOptions]="{ standalone: true }"
                    maxlength="1"
                    (input)="focusOnSecond($event)"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control text-center opt-text"
                    type="text"
                    placeholder="0"
                    [(ngModel)]="codeSecondDigit"
                    [ngModelOptions]="{ standalone: true }"
                    maxlength="1"
                    (input)="focusOnSecond($event)"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control text-center opt-text"
                    type="text"
                    placeholder="0"
                    [(ngModel)]="codeThirdDigit"
                    [ngModelOptions]="{ standalone: true }"
                    maxlength="1"
                    (input)="focusOnSecond($event)"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control text-center opt-text"
                    type="text"
                    placeholder="0"
                    [(ngModel)]="codeFourthDigit"
                    [ngModelOptions]="{ standalone: true }"
                    maxlength="1"
                  />
                </div>
              </div>
            </div>
            <div class="col-12">
              <button
                class="btn btn-primary d-block w-100 m-t-10"
                type="button"
                (click)="verifyCode()"
              >
                {{ "Verify" | translate }}
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="codeSent && codeVerified">
            <h6 class="mt-4">{{ "Create Your Password" | translate }}</h6>
            <div class="form-group">
              <input
                class="form-control"
                [type]="show ? 'text' : 'password'"
                name="password"
                formControlName="password"
                required=""
                placeholder="{{ 'New Password' | translate }}"
              />
              <div class="show-hide" (click)="showPassword()" *ngIf="!show">
                <div class="img">
                  <img src="assets/images/icons/show_pass.svg" alt="" />
                </div>
              </div>
              <div class="show-hide" (click)="showPassword()" *ngIf="show">
                <div class="img">
                  <img src="assets/images/icons/hide_pass.svg" alt="" />
                </div>
              </div>
              <div
                *ngIf="resetPasswordForm.controls['password'].touched && resetPasswordForm.controls['password'].errors?.['required']"
                class="text text-danger mt-1"
              >
                {{ "Validations.Password Is Required" | translate }}
              </div>
            </div>
            <div class="form-group">
              <label class="col-form-label">{{
                "Retype Password" | translate
              }}</label>
              <input
                class="form-control"
                type="password"
                name="password_confirmation"
                formControlName="password_confirmation"
                required=""
                placeholder="{{ 'Retype Password' | translate }}"
              />
              <div
                *ngIf="resetPasswordForm.controls['password_confirmation'].touched && resetPasswordForm.controls['password_confirmation'].errors?.['required']"
                class="text text-danger mt-1"
              >
                {{ "Validations.Password Is Required" | translate }}
              </div>
            </div>
            <div class="form-group mb-0">
              <button
                class="btn btn-primary d-block w-100"
                type="button"
                (click)="resetPassword()"
              >
                {{ "Change" | translate }}
              </button>
            </div>
          </ng-container>
          <p class="mt-4 mb-0 cursor-pointer">
            {{ "Already Have Password" | translate }}
            <a
              class="ms-2"
              (click)="this.isLogin = true; this.isReset = false"
              >{{ "Forms.Sign In" | translate }}</a
            >
          </p>
        </div>
      </form>
    </div>
  </div>
</div>